<template>
    <div>

      <HeaderBreadcrumbs
        :items="[
          { label: 'Coupon'},
        ]"
        title="All Coupon"
      />

      <div class="fle-col bg-white p-4 my-3 shadow-sm rounded-lg">
        <div class="bg-white  rounded-lg flex justify-between">
        <div class="relative">
          <svg
            class="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"
            width="20"
            height="20"
            fill="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10 2a8 8 0 016.32 12.906l4.387 4.387a1 1 0 01-1.415 1.415l-4.387-4.387A8 8 0 1110 2zm0 2a6 6 0 100 12 6 6 0 000-12z"
            />
          </svg>
          <input
            type="text"
            v-model="filter"
            placeholder="Search Coupon or Client/Buyer Name"
            class="rounded-lg bg-gray-50 w-96 border pl-10 py-2"
            @input="onInput"
          />
          <button
      v-if="filter"
      class="absolute top-1/2 right-3 transform -translate-y-1/2 text-gray-500 hover:text-gray-700"
      @click="actionReset"
      title="Clear search"
    >
      ✕
    </button>
        </div>
        <div class="flex justify-end">
          <button class="bg-blue-700 rounded-lg h-10 mr-3 text-white px-4 flex items-center justify-between">
            <router-link
              class="flex justify-between items-center"
              :to="{ path: `/coupon-add` }"
            >
            <span>
              <svg class="w-6 h-6 text-white dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 12h14m-7 7V5"/>
            </svg>
            </span>
            <span class="text-white">
              Add New
            </span>
            </router-link>
          </button>
          <t-dropdown>
          <div
            slot="trigger"
            slot-scope="{ mousedownHandler, focusHandler, blurHandler, keydownHandler }"
            class="flex"
          >
            <button
              class="flex items-center justify-center h-10 px-3 py-2.5 text-gray-500 bg-white border border-gray-400 rounded-lg"
              @mousedown="mousedownHandler"
              @focus="focusHandler"
              @blur="blurHandler"
              @keydown="keydownHandler"
            >
              <svg
                class="w-4 h-4 mr-1 text-gray-600 dark:text-white"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path d="M5.05 3C3.291 3 2.352 5.024 3.51 6.317l5.422 6.059v4.874c0 .472.227.917.613 1.2l3.069 2.25c1.01.742 2.454.036 2.454-1.2v-7.124l5.422-6.059C21.647 5.024 20.708 3 18.95 3H5.05Z" />
              </svg>
              Filter
              <svg
                class="w-5 h-5 ml-1 text-gray-600 fill-current"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <polygon
                  points="9.29289322 12.9497475 10 13.6568542 15.6568542 8 14.2426407 6.58578644 10 10.8284271 5.75735931 6.58578644 4.34314575 8"
                />
              </svg>
            </button>
          </div>
          <div class="w-custom bg-white absolute -right-2 pt-2 pb-3 border rounded-lg" slot-scope="{ hide, blurHandler }">
            <div class="block w-full px-4 py-2 text-sm text-gray-500 transition duration-150 ease-in-out focus:outline-none focus:bg-gray-100" role="menuitem">
              <div class="flex justify-between mb-3 mt-2">
                <div>Filter</div>
                <div @click="hide">
                  <svg   class="w-4 h-4 text-gray-800 dark:text-white cursor-pointer" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                  <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18 17.94 6M18 18 6.06 6"/>
                </svg>
                </div>
              </div>
              <div class="grid gap-4 grid-cols-2">
                <div>
                  <label class="text-gray-600 font-semibold mb-3">Status</label>
                  <StatusFilterComponent
                    v-model="coupontStatus"
                    :options="discountStatusOption"
                    :defaultText="'Select Status'"
                  />
                 </div>


                 <div>
                  <label class="text-gray-600 font-semibold mb-3">Coupon’s Availablity</label>
                  <StatusFilterComponent
                    v-model="availablityStatus"
                    :options="availablityStatusOption"
                     :defaultText="'Select Coupon’s Availablity'"

                  />
               </div>
              </div>
              <div class="mt-3">
                <button class="border bg-blue-500 px-4 py-2 text-white rounded-lg" @click="searchCoupon" @blur="blurHandler">
                  Filter
                </button>
                <button class="border bg-white text-gray-500 px-4 py-2 rounded-lg ml-2" @click="asyncClearFind() " @blur="blurHandler">Reset</button>
              </div>
            </div>
          </div>
        </t-dropdown>
        </div>
      </div>
      <div class="mt-4">
        <span class="my-4 block" v-if="typing">
            <em>Searching ..</em>
          </span>

        <TableCoupont
            :currentpage="currentPage"
            :perpage="perPage"
            :coupon="coupons"
            @sort-by="handleSortBy"
            :isLoading="isLoading"
          />

          <div v-if="totalRows / perPage > 1" class="flex justify-between ml-1 items-center mt-3">
            <div class="font-semibold">
            <span class="text-gray-500 font-normal">Showing </span> {{ currentPage }}-{{ perPage }} <span
              class="text-gray-500 font-normal">of</span> {{ parseInt(totalRows) }}
          </div>
          <div class="mb-2">
            <t-pagination
            :total-items="Number(totalRows)"
            :per-page="perPage"
            v-model="currentPage"
            class="rounded-lg"
             @update:modelValue="filterByPagination"
            />
          </div>
        </div>
      </div>
      </div>
  </div>
  </template>

  <script>
  import { mapState, mapActions } from 'vuex';
  import constant from '../../store/constant';
  import StatusFilterComponent from '../../components/form/StatusFilterComponent.vue';
  import TableCoupont from '../../components/coupon/table-coupont.vue';
  import HeaderBreadcrumbs from '@/components/HeaderBreadcrumbs.vue';

  const DISCOUNT_TYPES = Object.entries(constant.DISCOUNT_TYPES).map((item) => {
    return {
      text: item[0],
      value: item[1],
    }
  });


  const discountStatuses = [
    {
      text: 'Active',
      value: true,
    },
    {
      text: 'Inactive',
      value: false,
    },
  ]
  const availablityStatusOption = [
    {
      text: 'Valid',
      value: 'valid',
    },
    {
      text: 'Expired',
      value: 'expired',
    },
  ]
  export default {
    name: 'coupons',
    components: {
      TableCoupont,
      StatusFilterComponent,
      HeaderBreadcrumbs,
    },
    data() {
      return {
        currentPage: 1,
        perPage: 20,
        currentFrom: null,
        currentTo: null,
        filter: null,
        isLoadingSearch: false,
        isLoadingBtnSearch: false,
        debounce: null,
        sortOrder: [],
        start_date:null,
        end_date: null,
        range: {
          start: null,
          end: null,
        },
        masks: {
          input: 'YYYY-MM-DD',
        },
        typing: '',
        discountTypeOption: [...DISCOUNT_TYPES],
        discountType: null,
        discountStatusOption: [...discountStatuses],
        availablityStatusOption: [...availablityStatusOption],
        coupontStatus: null,
        availablityStatus:null,
        platformFilter:null,

      };
    },
    watch: {
      currentPage: function() {
        this.fetchCouponsFilter();
      },

      $route: {
        immediate: true,
        handler(to) {
          document.title =
            to.meta.title ||
            'Coupon | Content Management System Ebooks Gramedia.com';
        },
      },
      errorMessage: function() {
        if (!this.errorMessage) return;
        this.alertMsg(this.errorMessage, 'error');
      },
    },
    computed: {
      ...mapState({
        isLoading: (state) => state.coupons.isLoading,
        isError: (state) => state.coupons.isError,
        totalRows: (state) => state.coupons.totalRows,
        coupons: (state) => state.coupons.items,
        errorMessage: (state) => state.coupons.errorMessage,
      }),
    },
    mounted() {
      this.actionGetCouponts();
    },
    methods: {
      ...mapActions('coupons', [
        'fetchCouponts','actionGetCoupontsFilter',
      ]),
      actionRefresh() {
        this.actionGetCouponts();
      },
      actionReset() {
        this.actionGetCouponts();
        this.filter = ''
        this.coupontStatus = null;
        this.availablityStatus = null;
      },
      actionRefreshData() {
        if (this.filter.length == 0) {
          this.actionRefresh();
        }
      },
      actionGetCouponts() {
        let payload = {
          page: this.currentPage,
          limit: this.perPage,
        };
        this.fetchCouponts(payload);
      },

      formatPriceBasic(value) {
        let val = (value / 1).toFixed(0).replace('.', ',');
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      },
      asyncClearFind() {
        this.coupontStatus = null;
        this.availablityStatus = null;
        this.filter = ''
        this.actionGetCouponts();
      },
      onInput() {
       this.typing = 'You are typing';
       this.currentPage = 1;
       clearTimeout(this.debounceTimer);
       this.debounceTimer = setTimeout(() => {
        this.typing = null;
        this.searchCoupon();
      }, 600);
    },
    handleSortBy(criteria){
      this.sortOrder = criteria
      this.searchCoupon()

    },
    filterByPagination(page) {
    if (!page) return;
    this.currentPage = page;
    this.fetchCouponsFilter();
  },

  async fetchCouponsFilter(resetPage = false) {
  if (resetPage) {
    this.currentPage = 1;
  }

  const payload = {
    page: this.currentPage,
    limit: this.perPage,
    sort: this.sortOrder.order,
    order: this.sortOrder.criteria,
    is_active: this.coupontStatus,
    availability: this.availablityStatus,
    search: this.filter,
  };

  try {
    await this.actionGetCoupontsFilter(payload);
  } catch (error) {
    console.error("Error fetching coupons:", error);
  }
},
searchCoupon() {
  this.fetchCouponsFilter(true);
}

    },
  };
  </script>

  <style scoped>
  .discount {
    font-family: 'Avenir Next', 'effra', Helvetica, Arial, sans-serif;
  }
  input::placeholder {
    font-style: normal;
    font-size: 14px;
  }
  .w-custom {
    width: 750px;
  }

  </style>
